$bog_pazzle_help $mol_list
	rows /
		<= Rules $mol_text
			text \
				\## Как играть
				\
				\1. Загрузите картинку — подойдёт любое фото с телефона.
				\2. Выберите размер сетки: чем больше клеток, тем дольше собирать.
				\3. Нажмите «Начать игру».
				\
				\## Как двигать фрагменты
				\
				\- **Перетащите** фрагмент на место другого — они поменяются местами.
				\- Или **нажмите** на один фрагмент, потом на другой — тот же обмен, удобно на телефоне.
				\- Соседние фрагменты, вставшие рядом правильно, **слипаются** и дальше едут вместе.
				\- Фрагмент, попавший на своё место, **закрепляется** и больше не двигается.
				\
				\## Подсказки
				\
				\- Кнопка «Оригинал» показывает картинку целиком поверх доски.
				\- «Заново» перемешивает ту же картинку и обнуляет счёт.
				\- Номера фрагментов можно выключить в настройках — так сложнее.
				\
				\## Что сохраняется
				\
				\Партия сама записывается в браузер после каждого хода: можно закрыть
				\вкладку и вернуться позже. Список начатых пазлов лежит в «Моих пазлах».
